<template>

      <div class="about" style="  padding-right:230px;padding-left:280px;">
        <div class="clearfix" ></div>
      <div  >

      <div class="inwrap1" >
        <h2   style="visibility: visible; animation-name: fadeInUp;">发展历程</h2>
        <h3   data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div>
    </div>
        <div style="margin-top: 100px;">
        <el-row>
             <el-col :span="3"></el-col>
            <el-col :span="6" class="animate__animated animate__backInRight ">
                <el-timeline>
                    <el-timeline-item
                    placement="top"
                    hide-timestamp
                    v-for="(activity, index) in activities"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :hollow="activity.hollow"
                    :timestamp="activity.timestamp"
                    @click="handleClick(activity)"
                    >
                    <div class="year">{{activity.timestamp}}</div>
                        <div class="item">
                            <div style="margin-bottom: 5px;">
                            <span> {{ activity.title }}</span>
                            <!-- <span>{{item.depart}}</span>
                            </div>
                            <div>
                            <span>{{item.post}}</span>
                            <span>{{item.level}}</span> -->
                            </div>
                    </div>  

<!-- 
                        <h4>    {{ activity.title }}</h4> -->
                    </el-timeline-item>
                </el-timeline>
            </el-col>
            <el-col :span="12" class="animate__animated animate__backInLeft "  style=" margin-top: 0%;
              color: #686868;
              line-height: 2.0; font-family:  ui-sans-serif; text-align: left; /* 或者使用 left 的简写 left */ font-size:  16px !important;">
                <p>
                    {{  content }} 
                <!-- </el-card> -->
                </p>
                <!-- <el-card style="height: 500px;"> -->
          
            </el-col>
            <el-col :span="3"></el-col>
        </el-row>
        </div>
     </div>
  </template>
  <style scoped>
  .inwrap1 {
    color:#fff;
    z-index: 0;
    margin: -50px 0;
    padding: 20px;
    background-color: red;
    position: relative;
  }
  p {
    line-height: 2; /* 1.5倍的字体大小 */
    text-align: left; /* 或者不设置，因为left是默认值 */
    text-indent: 2em; 
} 
.year {
 
  position: absolute;
  left: -150px;
  top: 1px;
}
.item {
 
  border-left: 2px solid #fff;
 
  font-size: 15px;
}
span {
    padding-left: 10px;
  }
  </style>
  <script>
    import { MoreFilled } from '@element-plus/icons-vue'
    import { ref } from 'vue';
      export default {
        setup() {
            const content=ref('2021年10月，成立技术研发中心，引进了先进的原料药和制剂研究的小试、中试生产设备和检测仪器，每年投入不低于销售额10')
            const handleClick = (item) => {
                console.log('Clicked item:', item);
                  content.value= item.content
            };
                        const activities = ref([
                            { 
                            title: '太药控股（山西）集团 ',
                            content: '2021年10月，成立技术研发中心，引进了先进的原料药和制剂研究的小试、中试生产设备和检测仪器，每年投入不低于销售额10%的科研经费，与中北大学、山西医科大学、北京结核病诊疗技术创新联盟等科研机构合作，组建了33人年轻高水平的技术研发团队，短时间内攻克了多项技术瓶颈，2021年分别被省工信厅、省科技厅认定为省级技术中心和省级技术创新中心。同年12月，太药控股（山西）集团有限公司成立。',
                            timestamp: '2021年10月',
                            size: 'large',
                            type: 'primary',
                            icon: MoreFilled,
                            },
                            {
                            title: '山西众方医药',
                            content: '2019年2月，成立了专门的营销公司-山西众方医药有限公司，负责药品和医疗器械等产品的经营销售。',
                            timestamp: '2019年2月',
                            color: '#0bbd87',
                            },
                            {
                            title: '山西立业制药',
                            content: '2017年6月，成立山西立业制药有限公司，以生产中、西药制剂为主，中药提取和化学合成原料药为辅，共39个品种生产批文的现代化大型综合性制药企业。',
                            timestamp: '2017年6月',
                            size: 'large',
                            },
                            {
                            title: '山西太原药业',
                            content: '2004年1月15日，由自然人岳俊斌以资金投资入股75%、山西医药集团太原制药有限公司以地面上存量资产及药品批准文号等无形资产投资入股25%成立了山西太原药业有限公司。2007年底山西医药集团太原制药有限公司破产时，将在山西太原药业有限公司投资入股的25%股权，依法公开挂牌转让，国有股权全部退出。至此，山西太原药业有限公司成为民营全资公司，是原太原制药厂的唯一传承人。山西太原药业有限公司二十年来秉承“奉献人类健康事业”的企业宗旨，以“质量是企业的生命”为根本准则，坚持“准确、求精、持续改进，安全、有效、服务社会”的质量方针，奋勉图强、砥砺前行、追求卓越、不断创新,已发展成为集研发、生产、销售化学制剂和中药制剂的综合性药品生产的现代化高科技企业。',
                            timestamp: '2004年1月15日',
                            type: 'primary',
                            hollow: true,
                            },
                            {
                            title: '原太原制药厂',
                            content: '公司创建1958年，国家“一五”计划期间，为前苏联援建的全国156项重点项目之一，与华北制药、东北制药、新华制药时为全国制药行业“四大家族”。',
                            timestamp: '1958',
                            },
                        ])
            return {
                content,
                handleClick,
                activities
                };
            },
    };
  </script>